import {z} from 'zod';

import {isNotNil} from 'ramda';

import {UserAbsenceRequestBody} from '@dms/api/shared';

import {getAbsenceApiDateTime, userAbsenceAdminFormSchema} from './userAbsenceFormSchema';

type UserAbsenceFormValues = z.infer<typeof userAbsenceAdminFormSchema>;

/**
 * Maps the absence form values onto the API payload.
 *
 * `forwardEmailsToDelegate` is guarded rather than passed straight through: a
 * disabled `Checkbox` keeps its last form value, so a box ticked and then disabled
 * by clearing the contact person would otherwise still submit `true`.
 */
export function getUserAbsenceRequestBody(values: UserAbsenceFormValues): UserAbsenceRequestBody {
  return {
    dateFrom: getAbsenceApiDateTime(values.dateFrom, values.dateFromTime),
    dateTo:
      values.dateTo && values.dateToTime
        ? getAbsenceApiDateTime(values.dateTo, values.dateToTime)
        : null,
    absenceContactUserId: values.absenceContactUserId ?? null,
    description: values.description ?? null,
    forwardEmailsToDelegate:
      isNotNil(values.absenceContactUserId) && values.forwardEmailsToDelegate,
  };
}
